export enum SettingClass {
    TRISTATE_BOOLEAN = 'TRISTATE_BOOLEAN',
    BOOLEAN = 'BOOLEAN',
    STRING = 'STRING',
    INTEGER = 'INTEGER',
    ENUM = 'ENUM',
}

export interface SettingDefinitionMapping {
    settings: Setting[];
    categories: CategoryDefinition[];
}

export interface CategoryDefinition {
    identifier: string;
    settings: Setting[];
    subSettingCategories: CategoryDefinition[];
}

// TODO type-safety!
export interface SettingDefinition {
    identifier: string;
    defaultValue?: any;
    settingClass: SettingClass;
}

// TODO type-safety!
export interface Setting {
    settingDefinition: SettingDefinition;
    value?: any;
}

// TODO type-safety!
export interface UpdatedSetting {
    identifier: string;
    value?: any;
}
